<app-loader *ngIf="isLoading"></app-loader>
<div class="d-none d-lg-block">
  <div class="p-3 pb-0 d-flex justify-content-between align-items-center">
    <h4 class="mb-0">
    </h4>
    <div class="d-flex">
      <div>
        <div class="d-flex justify-content-center align-items-end">

          <img *ngIf="!currentUserData.avatarUrl" [src]="  'MYACCOUNT.AVATARPNG'| translate" alt="avatar" width="35"
            height="35" class="rounded-50 me-1 cursor-pointer" (click)="goToMyAccount()" />

          <img *ngIf="currentUserData.avatarUrl" [src]="currentUserData.avatarUrl" alt="avatar" alt="avatar" width="35"
            height="35" class="rounded-50 me-1 cursor-pointer" (click)="goToMyAccount()" />
        </div>
      </div>
    </div>
  </div>
</div>
<div class="d-block d-lg-none">
  <div class="p-3 pb-2 d-flex justify-content-between align-items-top bg-white menu-shadow">
    <div id="tabScreen">
      <img src="../../../assets/images/Menu.svg" (click)="openSidebar()" alt="" class="img-fluid rounded">

      <div *ngIf="showSidebar">
        <div class="sidebar-div" (click)="closeMblSidebar()">
          <div id="mbl-overlay">
            <nav class="sidebar mbl-sidebar" id="mySidebar">
              <div
                class="left-0 d-block fixed top-0 bottom-0 overflow-y-auto flex-row flex-nowrap overflow-hidden flex-column align-items-stretch px-0 d-flex flex-wrap align-items-center justify-content-between">
                <a [routerLink]="['/home']"
                  class="d-block text-s d-inline-block whitespace-nowrap text-uppercase fw-bold pt-4 ps-4">
                  <span class="q-logo1">
                    <img [src]="'SIDEBAR.Q-LOGO1' | translate" alt="" /></span>
                  <span class="q-logo2">
                    <img [src]="'SIDEBAR.Q-LOGO2' | translate" alt="" /></span>
                </a>

                <div
                  class="pt-30 ps-3 flex flex-column align-items-stretch relative shadow absolute top-0 left-0 right-0 z-40 overflow-y-auto overflow-x-hidden h-auto align-items-center flex-1 rounded">
                  <ul class="flex-column min-w-100 d-flex list-unstyled">
                    <li class="align-items-center q-sidebar-text" routerLink="/home/main-content"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.DBOARD2' | translate" class="me-2 inactiveIcon" alt="Dashboard" />
                        <img [src]="'SIDEBAR.DBOARD1' | translate" class="me-2 activeIcon" alt="Dashboard" />
                        <span> {{ "SIDEBAR.HOME" | translate }}</span>
                      </a>
                    </li>

                    <li class="align-items-center q-sidebar-text" routerLink="/home/manage-user"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.MANAGEUSER2' | translate" class="me-2 inactiveIcon" alt="manage-users" />
                        <img [src]="'SIDEBAR.MANAGEUSER1' | translate" class="me-2 activeIcon" alt="manage-users" />
                        <span>
                          {{ "SIDEBAR.MANAGEUSERS" | translate }}
                        </span>
                      </a>
                    </li>

                    <li class="align-items-center q-sidebar-text" routerLink="/home/manage-device"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.MYDEVICE2' | translate" class="me-2 inactiveIcon" alt="manage-devices" />
                        <img [src]="'SIDEBAR.MYDEVICE1' | translate" class="me-2 activeIcon" alt="manage-devices" />
                        <span>
                          {{ "SIDEBAR.MANAGEDEVICES" | translate }}
                        </span>
                      </a>
                    </li>
                    <li class="align-items-center q-sidebar-text" routerLink="/home/score-management"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.SCORE2' | translate" class="me-2 inactiveIcon" alt="history" />
                        <img [src]="'SIDEBAR.ACTIVESCORE' | translate" class="me-2 activeIcon" alt="history" />
                        <span>
                          {{ "SIDEBAR.SCOREMANAGEMENT" | translate }}
                        </span>
                      </a>
                    </li>
                    <li class="align-items-center q-sidebar-text" routerLink="/home/reports"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.REPORTS2' | translate" class="me-2 inactiveIcon" alt="reports" />
                        <img [src]="'SIDEBAR.REPORTS1' | translate" class="me-2 activeIcon" alt="reports" />
                        <span>
                          {{ "SIDEBAR.INSIGHTS" | translate }}
                        </span>
                      </a>
                    </li>
                    <li class="align-items-center q-sidebar-text" routerLink="/home/license-summary"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.LICENSESUMMARY2' | translate" class="me-2 inactiveIcon"
                          alt="license-summary" />
                        <img [src]="'SIDEBAR.LICENSESUMMARY1' | translate" class="me-2 activeIcon"
                          alt="license-summary" />
                        <span>
                          {{ "SIDEBAR.LICENSESUMMARY" | translate }}
                        </span>
                      </a>
                    </li>

                    <li class="align-items-center q-sidebar-text" routerLink="/home/settings"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.SETTINGS2' | translate" class="me-2 inactiveIcon" alt="settings" />
                        <img [src]="'SIDEBAR.SETTINGS1' | translate" class="me-2 activeIcon" alt="settings" />
                        <span>
                          {{ "SIDEBAR.SETTINGS" | translate }}
                        </span>
                      </a>
                    </li>

                    <!-- <li class="align-items-center q-sidebar-text" routerLink="/home/desktop-settings"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.SETTINGS2' | translate" class="me-2 inactiveIcon" alt="desktop-settings" />
                        <img [src]="'SIDEBAR.SETTINGS1' | translate" class="me-2 activeIcon" alt="desktop-settings" />
                        <span>
                          {{ "SIDEBAR.DESKFEATURE" | translate }}
                        </span>
                      </a>
                    </li> -->

                    <li class="align-items-center q-sidebar-text" routerLink="/home/activity-history"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.HISTORY2' | translate" class="me-2 inactiveIcon" alt="history" />
                        <img [src]="'SIDEBAR.HISTORY1' | translate" class="me-2 activeIcon" alt="history" />
                        <span>
                          {{ "SIDEBAR.ACTIVITYHISTORY" | translate }}
                        </span>
                      </a>
                    </li>

                    <li class="align-items-center q-sidebar-text" routerLink="/home/faq-support"
                      [routerLinkActive]="['active']">
                      <strong></strong>
                      <strong></strong>
                      <a>
                        <img [src]="'SIDEBAR.HELP2' | translate" class="me-2 inactiveIcon" alt="Help" />
                        <img [src]="'SIDEBAR.HELP1' | translate" class="me-2 activeIcon" alt="Help" />
                        <span>
                          {{ "SIDEBAR.HELP" | translate }}
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div>
      <img src="../../../assets/image-en/Logo.svg" alt="" class="img-fluid">
    </div>
    <div class="d-flex">
      <div>
        <div class="d-flex justify-content-center align-items-end">
          <div class="dropdown profile-dropdown">
            <button class="dropdown-toggle bg-transparent border-0 p-0" type="button" id="dropdownMenuButton1"
              data-bs-toggle="dropdown" aria-expanded="false">
              <img *ngIf="!currentUserData.avatarUrl" [src]="'MYACCOUNT.AVATARPNG'| translate" alt="avatar" width="35"
                height="35" class="rounded-50 me-1" />
              <img *ngIf="currentUserData.avatarUrl" [src]="currentUserData.avatarUrl" alt="avatar" alt="avatar"
                width="35" height="35" class="rounded-50 me-1" />
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li>
                <a class="dropdown-item cursor-pointer text-decoration-none"
                  (click)="goToMyAccount()">{{"MYACCOUNT.MYACCOUNT" | translate }} </a>
              </li>
              <li>
                <a class="dropdown-item cursor-pointer text-decoration-none"
                  (click)="openChangePassword()">{{"MYACCOUNT.CHANGEPWD" | translate }}</a>
              </li>
              <li>
                <a class="dropdown-item cursor-pointer text-decoration-none" (click)="logout()">{{"MYACCOUNT.LOGOUT" |
                  translate }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal mx-auto fade fixed top-0 left-0 w-100 h-100 outline-none overflow-y-auto" id="changePassword"
  data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel"
  aria-hidden="true">
  <div class="modal-dialog relative w-auto pointer-events-none adduserPopup modal-dialog-centered q-addDeviceModal">
    <div
      class="modal-content border-none rounded-25 shadow-lg relative d-flex p-4 px-sm-5 py-4 flex-column w-100 pointer-events-auto outline-none">
      <div class="modal-body relative p-0">
        <div class="mx-4 mt-0 mb-3 text-center">
          <h4 class="ms-2">
            <app-main-heading>
              <span title> {{"MYACCOUNT.UPDATEPWD" | translate }}</span>
            </app-main-heading>
          </h4>
        </div>
        <form [formGroup]="changePwdForm" (ngSubmit)="changePassword()">
          <div>
            <div class="mb-3">
              <label for="oldPassword" class="q-form-label">{{"MYACCOUNT.OLDPWD" | translate}} </label><span
                class="text-danger">*</span>
              <input (keyup)="passwordVerify('old')" (keydown)="removeSpace($event)" [type]="password"
                autocomplete="off" class="form-control q-form-control" formControlName="oldPassword"
                placeholder="{{ 'LOGIN.OLDPWD' | translate }}" />
              <div class="showpwdIcon" (click)="onClick('oldPwd')">
                <img [src]="'IMAGES.HIDEPWD'| translate" alt="" class="cursor-pointer"
                  *ngIf="!isOldPassword && f['oldPassword'].value?.length != 0" />
                <img [src]="'IMAGES.SHOWPWD'| translate" alt=""
                  *ngIf="isOldPassword && f['oldPassword'].value?.length != 0" class="cursor-pointer" />
              </div>
              <ng-container *ngIf="isIncorrectOldpwdErr">
                <small class="errMessage">
                  {{ isIncorrectOldpwdErr }}
                </small>
              </ng-container>
            </div>
            <div class="mb-3">
              <label for="newPassword" class="q-form-label">{{
                "LOGIN.NEWPASSWORD" | translate
                }}</label><span class="text-danger">*</span>
              <input [type]="newpasswords" autocomplete="off" (keydown)="removeSpace($event)"
                class="form-control q-form-control" (keyup)="passwordVerify('new')" formControlName="password"
                placeholder="{{ 'LOGIN.ENTERNEWPASSWORD' | translate }}" />
              <div class="showpwdIcon" (click)="onClick('newPwd')">
                <img [src]="'IMAGES.HIDEPWD'| translate" alt=""
                  *ngIf="!isNewPassword && f['password'].value?.length != 0" class="cursor-pointer" />
                <img [src]="'IMAGES.SHOWPWD'| translate" alt=""
                  *ngIf="isNewPassword && f['password'].value?.length != 0" class="cursor-pointer" />
              </div>
              <div class="mw-340">
                <p class="errMessage" *ngIf="changePwdForm.controls['password'].errors">
                  {{"MYACCOUNT.PWDCRITERIA" | translate }} <br />
                </p>
              </div>

              <ng-container *ngIf="oldPasswordNotMatch">
                <p class="errMessage">
                  {{"MYACCOUNT.PWDCANTBESAME" | translate}}
                </p>
              </ng-container>
            </div>
            <div>
              <label for="newPassword" class="q-form-label">{{
                "LOGIN.CONFIRMPASSWORD" | translate
                }}</label><span class="text-danger">*</span>
              <input [type]="passwords" autocomplete="off" class="form-control q-form-control"
                (keydown)="removeSpace($event)" (keyup)="onFocusOut()" formControlName="newPassword"
                placeholder="{{ 'LOGIN.REENTERNEWPASS' | translate }}" />
              <div class="showpwdIcon" (click)="onClick('confPwd')">
                <img [src]="'IMAGES.HIDEPWD'| translate" alt="" *ngIf="
                    !isConfirmPassword && f['newPassword'].value?.length != 0
                  " class="cursor-pointer" />
                <img [src]="'IMAGES.SHOWPWD'| translate" alt=""
                  *ngIf="isConfirmPassword && f['newPassword'].value?.length != 0" class="cursor-pointer" />
              </div>
            </div>
            <ng-container *ngIf="PasswordNotMatch">
              <p class="errMessage">
                {{ PasswordNotMatch }}
              </p>
            </ng-container>
            <ng-container *ngIf="pwdNotMatch">
              <p class="errMessage">
                {{ "LOGIN.PASSWORDDOESNOTMATCH" | translate }}
              </p>
            </ng-container>
            <div class="mb-3 mt-3">
              <div class="q-form-label">
                {{ "LOGIN.PASSWORDCRITERIA" | translate }}
              </div>
              <div class="pwd-criteria">
                <div>1. {{ "LOGIN.PASSWORDCONTAINS" | translate }}</div>
                <div>
                  2. {{"MYACCOUNT.PWDCRITERIA" | translate}}
                </div>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <button type="submit" [disabled]="
                changePwdForm.invalid || pwdNotMatch || oldPasswordNotMatch
              " [ngClass]="
                changePwdForm.invalid || pwdNotMatch || oldPasswordNotMatch
                  ? 'q-invalid-button mb-3 w-100'
                  : 'submit-btn bg-orgclr mb-3 w-100'
              ">
              {{"MYACCOUNT.UPDATEPWD" | translate}}
            </button>
            <button class="cancel-btn btn-block w-100 bg-cancelbtn" data-bs-dismiss="modal" type="button"
              (click)="closemodal()">
              {{ "LOGIN.CANCEL" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>